import { ProgramAreas } from "./models";
 
export enum budgetTypes {
    HC1 = "HC1",
    RC1 = "RC1",
    CFWB1 = "CFWB1",
    SI1 = "SI1",
    HE1 ="HE1",
    GENERAL = "GENERAL"
}

export interface iProgramAreas {
    label: string,
    id: budgetTypes
}

export const programAreasList: iProgramAreas[] = [
    { label: ProgramAreas.HC,  id: budgetTypes.HC1 },
    { label: ProgramAreas.RC,  id: budgetTypes.RC1 },
    { label: ProgramAreas.CFWB,  id: budgetTypes.CFWB1 },
    { label: ProgramAreas.SI,  id: budgetTypes.SI1 },
    { label: ProgramAreas.HE,  id: budgetTypes.HE1 },
    { label: ProgramAreas.GENERAL,  id: budgetTypes.GENERAL },
    { label: ProgramAreas.ADMIN,  id: budgetTypes.GENERAL } // ADMIN maps to GENERAL budget type
]

export const translateProgramArea = (programAreaString: string): budgetTypes => {
    const programAreaObj = programAreasList.find(area => area.label === programAreaString);
    return programAreaObj?.id || budgetTypes.GENERAL; // Default to GENERAL if not found
}